import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
 
export default () => {

  const moduleName = "roles";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.roles_destroy, location.search]);

  useEffect(() => {
    if (appReducer.roles_list != undefined) {
      setRows(appReducer.roles_list.data)
      setTotalPages(appReducer.roles_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام فارسی',
      selector: row => row.name,
    },
    {
      name: 'نام لاتین',
      selector: row => row.slug,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table  count={totalPages} columns={columns} data={rows} />;

};
